import faireDirectDiscounts from "@faire/web-api--source/endpoints/www/api/help-center/self-serve-faire-direct-discounts/get";

import {
  InstantAnswerRequiredData,
  InstantAnswerRequiredDataFn,
} from "../types";

const NO_FAIRE_DIRECT_CONTEXT: InstantAnswerRequiredData = {
  field: "faireDirectDiscountsContext",
  data: undefined,
};

export const FaireDirectDiscountsDataFn: InstantAnswerRequiredDataFn = () => {
  return faireDirectDiscounts()
    .then<InstantAnswerRequiredData>((response) => ({
      field: "faireDirectDiscountsContext",
      data: response,
    }))
    .catch(() => NO_FAIRE_DIRECT_CONTEXT) as Promise<InstantAnswerRequiredData>;
};
